import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import useAuth from "@/hooks/useAuth";
import storage from "@/utils/api/storage";
import { IMenuLink } from "@/utils/models/core";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import { clsx } from "clsx";
import { NavLink, useLocation } from "react-router-dom";

interface IMenuHeader {
	menu: IMenuLink[];
}
const MenuHeader = ({ menu }: IMenuHeader) => {
	const { user } = useAuth();
	const location = useLocation();
	const isAdminView = storage.getItem("accessStatus") === 'Admin'

	return (
		<div className="border-b">
			<div className="flex container px-2 mx-auto justify-between items-center gap-2">
				<ScrollArea className="max-w-fit">
					<nav className="py-4">
						<ul className="flex space-x-5">
							{menu.map((item: IMenuLink, index: number) => {
								return (
									((item.isAdminOnly && isAdminView) || !item.isAdminOnly) && <li key={index}>
										<NavLink
											key={index}
											to={item.to}
											className={clsx(
												"text-nowrap",
												"text-opus-gray-400 hover:text-opus-blue-100 hover:border-b hover:border-b-2 hover:border-opus-blue-100 py-4",
												location.pathname === item.to &&
												"!text-opus-blue-100 border-b-2 border-opus-blue-100 "
											)}>
											{item.label}
										</NavLink>
									</li>
								);
							})}
						</ul>
					</nav>
					<ScrollBar orientation="horizontal" />
				</ScrollArea>
				<div className="">
					<div className="flex flex-row items-center space-x-1 text-sm text-opus-gray-300">
						<UserCircleIcon className="w-5 h-5 mr-1" /> {storage.getItem("accessStatus")}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MenuHeader;
